import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {RAPPORT as name} from '../../../store/slices/config'
import {_fetchEngines} from '../../Engin/api/api'
import {_fetchSites} from '../../Site/api/api'
import {
  _buildRapport,
  _deleteRapport,
  _fetchDetailsWeek,
  _fetchEnginesRapport,
  _fetchListRpt,
  _fetchStatusRapport,
  _fetchWeekTime,
  _getListRpt,
} from '../api'
import moment from 'moment'
import {setToastParams} from '../../../store/slices/ui.slice'

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const fetchListRapport = createAsyncThunk(
  `${name}/fetchListRapport`,
  async (_args, {getState, dispatch}) => {
    dispatch(setListSelected([]))
    if (_args === 'engin') {
      let res = await _fetchEnginesRapport()
      if (!res.error) {
        dispatch(setListRapport(res.data))
        dispatch(setLoadingRpt(false))
      }
    } else {
      let res = await _fetchSites({IDCustomer: 0})
      if (!res.error) {
        dispatch(setListRapport(res.data))
        dispatch(setLoadingRpt(false))
      }
    }
  }
)

export const fetchListRpt = createAsyncThunk(
  `${name}/fetchListRpt`,
  async (_args, {getState, dispatch}) => {
    let res = await _fetchListRpt()
    if (!res.error) {
      dispatch(setListRpt(res.data))
    }
  }
)

export const fetchWeekTime = createAsyncThunk(
  `${name}/fetchWeekTime`,
  async (_args, {getState, dispatch}) => {
    try {
      let res = await _fetchWeekTime(_args)
      if (!res.error) {
        dispatch(setWeekTime(res.data))
      }
    } catch (err) {
      console.log('err fetchWeekTime', err)
    }
  }
)

export const fetchDetailWeek = createAsyncThunk(
  `${name}/fetchDetailWeek`,
  async (_args, {getState, dispatch}) => {
    try {
      let res = await _fetchDetailsWeek(_args)
      if (!res.error) {
        dispatch(setDetailWeek(res.data?.[0] || []))
      }
    } catch (err) {
      console.log('err fetchDetailWeek', err)
    }
  }
)

export const fetchListRptById = createAsyncThunk(
  `${name}/fetchListRptById`,
  async (_args, {getState, dispatch}) => {
    let res = await _getListRpt({id: _args})
    if (!res.error) {
      dispatch(setDataRapport(res || []))
      return true
    }
  }
)

export const deleteRapport = createAsyncThunk(
  `${name}/deleteRapport`,
  async (_args, {getState, dispatch}) => {
    let res = await _deleteRapport({id: _args})
    if (!res.error) {
      dispatch(fetchListRpt())
      return true
    }
  }
)

export const saveRapport = createAsyncThunk(
  `${name}/saveRapport`,
  async (_args, {getState, dispatch}) => {
    const {selectedRapport, listSelected} = getState()[name]
    let begDate = moment(_args.date[0]).format('YYYY-MM-DD')
    let endDate = moment(_args.date[1]).format('YYYY-MM-DD')

    let obj = {
      ref: listSelected,
      object: selectedRapport.decs,
      begDate: begDate,
      endDate: endDate,
      title: _args?.title,
    }
    const res = await _buildRapport(obj)

    dispatch(
      setToastParams({
        show: true,
        severity: 'success',
        summary: 'SUCCESS',
        detail: 'Rapport bien enregistré',
        position: 'top-right',
      })
    )

    if (!res.error) {
      dispatch(setLoadingRapport(true))
      dispatch(setChoseRapport(false))
      dispatch(setShowSettingRapport(false))
      dispatch(setDataRapport(res?.res || []))

      let loading = true
      let rapportSat = null

      while (loading) {
        rapportSat = await _fetchStatusRapport({id: res?.generatorId})
        if (rapportSat?.data?.[0]?.status === 1) {
          loading = false
          dispatch(setLoadingRapport(false))
          window.open(res?.filepath, '_blank')
        } else {
          await delay(3000) // 3-second delay between requests
        }
      }
    }
  }
)

const initialState = {
  choseRapport: false,
  showSettingRapport: false,
  listRapport: [],
  listSelected: [],
  dataRapport: [],
  listRpt: [],
  weekTime: [],
  detailWeek: [],
  loadingRapport: false,
  loading: false,
  selectedRapport: {
    title: '',
    icon: '',
    decs: '',
  },
}

const rapportsSlice = createSlice({
  name,
  initialState,
  reducers: {
    setChoseRapport: (state, {payload}) => {
      state.choseRapport = payload
    },
    setListSelected: (state, {payload}) => {
      state.listSelected = payload
    },
    setShowSettingRapport: (state, {payload}) => {
      state.showSettingRapport = payload
    },
    setDetailWeek: (state, {payload}) => {
      state.detailWeek = payload
    },
    setWeekTime: (state, {payload}) => {
      state.weekTime = payload
    },
    setListRpt(state, {payload}) {
      state.listRpt = payload
    },
    setSelectedRapport: (state, {payload}) => {
      state.selectedRapport = {
        ...state.selectedRapport,
        ...payload,
      }
    },
    setListRapport: (state, {payload}) => {
      state.listRapport = payload
    },
    setDataRapport: (state, {payload}) => {
      state.dataRapport = payload
    },
    setLoadingRpt: (state, {payload}) => {
      state.loading = payload
    },
    setLoadingRapport: (state, {payload}) => {
      state.loadingRapport = payload
    },
  },
})

export const getChoseRapport = (state) => state[name].choseRapport
export const getShowSettingRapport = (state) => state[name].showSettingRapport
export const getSelectedRapport = (state) => state[name].selectedRapport
export const getListRapport = (state) => state[name].listRapport
export const getLoadingRpt = (state) => state[name].loading
export const getListSelected = (state) => state[name].listSelected
export const getDataRapport = (state) => state[name].dataRapport
export const getLoadingRapport = (state) => state[name].loadingRapport
export const getListRpt = (state) => state[name].listRpt
export const getWeekTime = (state) => state[name].weekTime
export const getDetailWeek = (state) => state[name].detailWeek

export const {
  setChoseRapport,
  setDetailWeek,
  setShowSettingRapport,
  setSelectedRapport,
  setListRapport,
  setLoadingRapport,
  setDataRapport,
  setLoadingRpt,
  setListSelected,
  setWeekTime,
  setListRpt,
} = rapportsSlice.actions
export default rapportsSlice.reducer
